import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { buttonVariants } from "@react/shared/ui/Button"
import Button from "@react/shared/ui/Button"
import { iconButtonVariants } from "@react/shared/ui/IconButton"
import { t, fmtPeriod } from "../helpers/format"
import ExportMenu from "./ExportMenu"

const Header = ({ board, exportUrl, planningUrl, preferencesUrl, onClose }) => (
  <div className="px-7 pt-6 pb-4 flex flex-wrap items-start justify-between gap-4">
    <div className="min-w-0">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
        <FontAwesomeIcon icon="helmet-safety" className="text-brand-500" />
        {t("eyebrow")}
      </div>
      <h1 className="text-[22px] font-bold tracking-tight text-slate-900 mt-1">{t("title")}</h1>
      <p className="text-[12.5px] text-slate-500 mt-0.5">
        {t("subtitle", { period: fmtPeriod(board.from, board.to) })}
      </p>
    </div>

    <div className="flex items-center gap-2">
      <a href={planningUrl} className={buttonVariants({ variant: "ghost", size: "md" })}>
        <FontAwesomeIcon icon="calendar-days" className="text-slate-400" />
        {t("actions.planning")}
      </a>
      <ExportMenu exportUrl={exportUrl} />
      {board.can?.close && (
        <Button variant="secondary" onClick={onClose}>
          <FontAwesomeIcon icon="lock" className="text-slate-400" />
          {t("actions.close_period")}
        </Button>
      )}
      <a
        href      = {preferencesUrl}
        title     = {t("actions.preferences")}
        aria-label = {t("actions.preferences")}
        className = {`${iconButtonVariants({ size: "lg" })} border border-slate-300 bg-white`}
      >
        <FontAwesomeIcon icon="gear" />
      </a>
    </div>
  </div>
)

export default Header
